"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BasketItemSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'grid',
        gridTemplateColumns: '80px 130px 1fr',
        gridTemplateRows: 'repeat(5, 1fr)',
        gridTemplateAreas: "\n    'productImage description .'\n    'productImage itemCode .'\n    'productImage . .'\n    'productImage quantityPicker points'\n    'productImage quantityPicker price'",
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3, 0),
        '&:not(:last-child)': {
            borderBottom: "1px solid ".concat(theme.palette.grey[200])
        }
    };
});
const ProductImage = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'productImage',
        height: 110,
        width: 80
    };
});
const Description = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'description',
        marginLeft: theme.spacing(2),
        height: 14,
        width: 85
    };
});
const ItemCode = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'itemCode',
        marginLeft: theme.spacing(2),
        height: 12,
        width: 40
    };
});
const QuantityPicker = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        gridArea: 'quantityPicker',
        display: 'flex',
        marginLeft: theme.spacing(2)
    };
});
const QuantityPickerInput = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, 2),
        height: 30,
        width: 30
    };
});
const Price = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'price',
        marginLeft: 'auto',
        height: 14,
        width: 70
    };
});
const Points = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'points',
        marginLeft: 'auto',
        height: 12,
        width: 40
    };
});
const BasketItemSkeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProductImage, {
                animation: "wave",
                variant: "rounded"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Description, {
                animation: "wave",
                variant: "rounded"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ItemCode, {
                animation: "wave",
                variant: "rounded"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(QuantityPicker, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                        animation: "wave",
                        variant: "circular",
                        height: 30,
                        width: 30
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuantityPickerInput, {
                        animation: "wave",
                        variant: "rectangular"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                        animation: "wave",
                        variant: "circular",
                        height: 30,
                        width: 30
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Points, {
                animation: "wave",
                variant: "rounded"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Price, {
                animation: "wave",
                variant: "rounded"
            })
        ]
    });
exports.BasketItemSkeleton = BasketItemSkeleton;
